export default "__VITE_PUBLIC_ASSET__1bfb682a__"